import { type CustomResolversContext } from '../types';

const teamInSlack = async (
	root: any,
	args: { teamId: string; teamName: string },
	context: CustomResolversContext,
) => {
	const { teamId, teamName } = args;
	const url = `${
		context.url.stargateRoot
	}/teamsslack/api/team/${teamId}?teamName=${encodeURIComponent(teamName)}`;

	return context
		.fetch(url)
		.then((data) => data.json())
		.then(
			(data) =>
				({
					id: teamId, // this helps to update cache easily
					...data,
				}) as unknown,
		);
};

export default teamInSlack;
